import React, { useState, useEffect }  from 'react';
import './main.scss';
import { Form, Input, Button, Image } from 'antd';
import LoginBox from './LoginBox/loginBox.js';

function Main() {
    // const [activeKey, setActiveKey] = useState(true);

    // const switchActive = (val) => {
    //     setActiveKey(val);
    // }

    return (
        <main className="main">
            <div className="login-wrapper">
                {/* <img className="browser-tips" src={browserTips} /> */}
                    <div className="browser-tips" />
                    {/* <img className="login-method-switch"></img> */}
                    <div className="login-form">
                        <div className="form-header">
                            游客登录
                        </div>
                        <div className="form-body">
                            <LoginBox />
                        </div>
                    </div>
            </div>
        </main>
    );
}

export default Main;
